<template>
    <div class="columns is-mobile size-row mb-1" v-bind:class="{'has-background-success':(sizeCompleted === true)}">
        <div class="column has-text-right">
            {{ size.name }}
        </div>
        <div class="column has-text-centered">
            <input type="tel" class="input is-small has-text-centered" v-model="originalQuantityOutstanding" ref="inputQty"/>
        </div>
        <div class="column">
            <button class="button is-small is-success" v-if="sizeCompleted!=true" @click="submitForm()" :disabled="working==true" >Complete</button>
        </div>
    </div>
</template>

<script>
export default 
{
    name: 'SizeRow',
 props: ['size', 'order', 'working', 'area'],
 data() {
     return {
         originalQty : this.order[this.size.database_name] + this.order[this.size.database_name + "_GK"],  
         
     }
 },
 computed: {
    area_logs: function () {
       let makeup_area = this.area
       let area_logs =  this.order.makeup_logs.filter(function(u) {
           if(  u.makeup_area == makeup_area) 
           {
              console.log(u)
             return 1
           }
         })

         return area_logs
      
    },
    quantityCompleted: function() {
         let currentSizeId = this.size.id
         
             // Check the makeup log for completed rows for this order. If equal or greater than qty ordered, disable row
             let quantityCompleted = this.area_logs.reduce(function (previousValue, currentValue) {
                 if(currentValue.size_id == currentSizeId)
                 {
                    return previousValue + currentValue.qty
                 }
                 else{
                     return previousValue
                 }
                
                }, 0)

           //  if(totalCompleted >= this.originalQty)
           // {
                return quantityCompleted
           // }

         
     },
     sizeCompleted: function() {
         return this.quantityCompleted >= this.originalQty
     },
      originalQuantityOutstanding : function() {
            return this.originalQty - this.quantityCompleted
     } ,
 },
 methods: {
     submitForm()
     {
         this.$emit('submitForm', this.$refs.inputQty.value)
     },
    
 }
}
</script>
